import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Report from '../views/Report.vue'
import Result from '../views/Result.vue'
import Admin from '../views/Admin.vue'
import Quiz from '../views/Quiz.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: Quiz
  },
  {
    path: '/result/:answerId',
    name: 'Result',
    component: Result
  },
  {
    path: '/admin',
    name: 'Admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/Admin.vue')
    },
    meta: { requiresAuth: false },
    // component: Admin,
    children: [
      {
        path: 'login',
        name: "Login",
        component: Login,
        meta: { requiresAuth: false }
      },
      {
        path: 'report',
        name: "Report",
        component: Report,
        meta: { requiresAuth: true }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  routes
})


// Redirect to login if not logged in
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && token == null) {
    next('/admin/Login');
  } else {
    next();
  }

})
export default router
